const config = {
  state: {
    loading: false,
    pageLoading: false,
    times: 1
  },
  mutations: {
    SET_LOADING (state, value) {
      state.loading = value
    },
    SET_PAGE_LOADING (state, value) {
      state.pageLoading = value
    },
    SET_TIMES (state, value) {
      state.times = value
    }
  },
  actions: {
    changeLoadingTrue ({commit}) {
      commit('SET_LOADING', true)
    },
    changeLoadingFalse ({commit, state}) {
      if (!state.pageLoading) commit('SET_LOADING', false)
    },
    changeAllLoadingTrue ({commit}) {
      commit('SET_LOADING', true)
      commit('SET_PAGE_LOADING', true)
    },
    changeAllLoadingFalse ({commit}) {
      commit('SET_LOADING', false)
      commit('SET_PAGE_LOADING', false)
    }
  }
}

export default config



// WEBPACK FOOTER //
// ./src/store/modules/config.js